export const CREATE_SIGNUP_GENERATOR_SUCCESS = 'EMAIL-SIGNUP-GENERATOR/CREATE_SIGNUP_GENERATOR_SUCCESS';
export const CREATE_SIGNUP_GENERATOR_ERROR = 'EMAIL-SIGNUP-GENERATOR/CREATE_SIGNUP_GENERATOR_ERROR';
export const CLEAR_SIGNUP_GENERATOR_STATUS = 'EMAIL-SIGNUP-GENERATOR/CLEAR_SIGNUP_GENERATOR_STATUS';

export const DETELE_SIGNUP_GENERATOR_SUCCESS = 'EMAIL-SIGNUP-GENERATOR/DETELE_SIGNUP_GENERATOR_SUCCESS';
export const DETELE_SIGNUP_GENERATOR_ERROR = 'EMAIL-SIGNUP-GENERATOR/DETELE_SIGNUP_GENERATOR_ERROR';

export const FETCH_SIGNUP_GENERATOR = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_GENERATOR';
export const FETCH_SIGNUP_GENERATOR_ERROR = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_GENERATOR_ERROR';
export const CLEAR_SIGNUP_GENERATOR = 'EMAIL-SIGNUP-GENERATOR/CLEAR_SIGNUP_GENERATOR';

export const UPDATE_SIGNUP_GENERATOR_SUCCESS = 'EMAIL-SIGNUP-GENERATOR/UPDATE_SIGNUP_GENERATOR_SUCCESS';
export const UPDATE_SIGNUP_GENERATOR_ERROR = 'EMAIL-SIGNUP-GENERATOR/UPDATE_SIGNUP_GENERATOR_ERROR';
export const CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS = 'EMAIL-SIGNUP-GENERATOR/CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS';

export const FETCH_SIGNUP_SUBSCRIBERS_LIST = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_SUBSCRIBERS_LIST';
export const FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR';
export const FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR';

export const FETCH_SIGNUP_SUBSCRIBERS_CSV = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_SUBSCRIBERS_CSV';
export const FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR = 'EMAIL-SIGNUP-GENERATOR/FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR';
export const CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV = 'EMAIL-SIGNUP-GENERATOR/CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV';
